import React from "react";

export default (props) => {

	return (
		<span className="switch">
			<label>
				<input
					type="checkbox"
					checked={props.checked}
					disabled={props.disabled}
					onChange={props.onChange} />
				<span className="lever" />
			</label>
		</span>
	);
};



// WEBPACK FOOTER //
// ./src/js/common/components/form/Switch.js